import React from 'react';
import './MikaCard.scss';

interface MikaCardProps {
    header?: React.ReactNode;
    body: React.ReactNode;
    footer?: React.ReactNode;
    onClick?: () => void;
    className?: string;
    selected?: boolean;
}

const MikaCard: React.FC<MikaCardProps> = ({
    header,
    body,
    footer,
    onClick,
    className = '',
    selected = false
}) => {
    return (
        <div
            className={`mika-card ${selected ? 'mika-card-selected' : ''} ${onClick ? 'mika-card-clickable' : ''} ${className}`}
            onClick={onClick}
        >
            {header && <div className="mika-card-header">{header}</div>}
            <div className="mika-card-body">{body}</div>
            {footer && <div className="mika-card-footer">{footer}</div>}
        </div>
    );
};

export default MikaCard;
